import stopHandler from './stopHandler'
import selectric from 'selectric'
import { FetchData } from './utils/fetchData'
import CatalogFilter from './catalogFilter'
import Preloader from './preloader'
import { bubble } from './utils/bubble'
import { onAjaxContentLoaded } from './generic/evented'

export default class CustomSelect {

  els = {
    container: '[data-select="container"]',
    multiSelectLabel: '[data-multi-label]',
    multiSelectListContainer: '[data-multi-list]',
    multiOption: '[data-multi-item]',
    multiOptionLabel: '[data-multi-item-label]',
    optionLabel: '[data-select-label]',
    optionValue: '[data-select-value]',
    selectContainer: '.select_custom',
    headSelectContainer: '.select_custom__head',
  }

  constructor () {
    stopHandler('.select_custom__item .ichek-custom input')
    this.nodes = document.querySelectorAll(this.els.container)
    this.selectContainer = document.querySelector(this.els.selectContainer)
    this.bindEvents()
    this.bindCustomEvent()
  }

  /**
   * For select with checkbox
   * @param target {HTMLElement}
   */

  checkField ({ target }) {
    target.parentNode.classList.toggle('option_checked')
  }

  /**
   * @param target {HTMLElement}
   * @param clickFlag {Boolean}
   */

  toggle ({ target }, clickFlag) {
    if (target && target.dataset.select === 'container') {
      target.toggleAttribute('opened')
    }
    if (clickFlag) {
      target.closest(this.els.selectContainer).toggleAttribute('opened')
    }
  }

  /**
   * @param target {HTMLElement}
   */

  clickOutside ({ target }) {
    if (this.selectContainer && !target.closest(this.els.selectContainer)) {
      const allSelect = document.querySelectorAll(this.els.selectContainer)
      allSelect.forEach(select => {
        if (select.getAttribute('opened') !== null) {
          select.toggleAttribute('opened')
        }
      })
    }
  }

  resetSelect () {
    App.CustomSelect = new CustomSelect()
  }

  bindEvents () {
    document.addEventListener('click', (e) => this.clickOutside(e))
    this.nodes.forEach((node) => {
      const selectItems = node.querySelectorAll('.ichek-custom')
      const selectHead = node.querySelector(this.els.headSelectContainer)

      node.addEventListener('click', (e) => {
        this.toggle(e, false)
      })
      selectHead.addEventListener('click', (e) => {
        this.toggle(e, true)
      })
      selectItems.forEach((item) => {
        item.addEventListener('click', (e) => {
          this.checkField(e)
        })
      })
    })
  }

  bindCustomEvent () {
    $(document).off(CatalogFilter.bubbles.newCatalogTable, this.resetSelect)
    $(document).on(CatalogFilter.bubbles.newCatalogTable, this.resetSelect)
  }
}

export class CustomSelectWithSelectric {

  selects = [
    {
      selector: '[data-js-selectric]',
      option: {
        onInit: function () {
          $('.selectric-items').find('ul').addClass('catalog__select-items')
          $('.selectric').addClass('catalog-select select_custom catalog__select')
          $('.button').addClass('select_custom__catalog-icon')
        }
      }
    }
  ]

  static bubbles = {
    change: "customSelect::change"
  }

  constructor () {
    this.init()
    this.bindEvents()
  }

  resetSelect () {
    App.CustomSelectWithSelectric = new CustomSelectWithSelectric()
  }

  init () {
    this.selects.forEach((select) => {
      if (document.querySelector(select.selector)) {
        document.querySelectorAll(select.selector).forEach(selectNode => {
          $(selectNode).selectric(select.option)
        })
      }
    })
  }

  bindEvents () {
    $(document).off(CatalogFilter.bubbles.newCatalogTable, this.resetSelect)
    $(document).on(CatalogFilter.bubbles.newCatalogTable, this.resetSelect)
  }
}

export class DynamicCustomSelect {

  selects = [
    {
      selector: '[data-js-dynamic-selectric]',
      option: {
        onInit: function () {
          $('.selectric-items').find('ul').addClass('catalog__select-items')
          $('.selectric').addClass('catalog-select select_custom catalog__select')
          $('.button').addClass('select_custom__catalog-icon')
        },
        onChange: function (element) {
          bubble(document, CustomSelectWithSelectric.bubbles.change, element)
          DynamicCustomSelect.submitFilterData(element, this)
        },
      }
    }
  ]

  constructor () {
    this.init()
    this.bindEvents()
    // onAjaxContentLoaded((e) => {
    //   if (e.detail?.DynamicCustomSelectUploaded) {
    //     this.init()
    //   }
    // })
  }

  static async submitFilterData (element) {
    let ajaxUrl = element.closest('[data-js-ajax-url]')?.dataset?.jsAjaxUrl
    if (ajaxUrl) {
      if (window.location.search) {
        let additionalQuery = window.location.search.split('?')[1];
        ajaxUrl += `?${additionalQuery}`
      }
      // TODO DE в режиме разарботки делаем get, на проде post
      let requestData;
      if (process.env.NODE_ENV === "development") {
        requestData = await FetchData.getData(ajaxUrl)
      } else {
        requestData = await FetchData.postData({[element.id]:element.value},ajaxUrl)
      }

      if (requestData) {
        requestData.hasOwnProperty('query') ? history.pushState(null, '', `?${requestData.query}`) : false
      }
      CatalogFilter.insertDataFromQuery(requestData)
      Preloader.hide()
    }
  }

  resetSelect () {
    App.DynamicCustomSelect = new DynamicCustomSelect()
  }

  init () {
    this.selects.forEach((select) => {
      document.querySelectorAll(select.selector).forEach(selectNode => {
        $(selectNode).selectric(select.option)
      })
    })
  }

  bindEvents () {
    $(document).off(CatalogFilter.bubbles.newCatalogTable, this.resetSelect)
    $(document).on(CatalogFilter.bubbles.newCatalogTable, this.resetSelect)
  }
}
